var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-family-compatibility-requirements-count"
  }, [(_vm.hasNoRequirements) ? _c('span', [_c('text-placeholder')], 1) : (_vm.hasSingleRequirement) ? _c('span', [_vm._v(_vm._s(_vm.$t('counts.single')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('counts.multiple', {
    count: _vm.requirementsCount
  })))])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cab57392","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/ProductFamilyCompatibilityRequirementsCount.vue
// module id = 2108
// module chunks = 0